import videojs from 'video.js';

var _customScripts = {};
var uid;

function isObject(obj) {
  return typeof obj === 'object';
}

function isFunction(str){
  return typeof str === 'function';
}

function isPromise(obj){
  return obj instanceof Promise;
}

function isIFrame() {
  return window.parent && window.location != window.parent.location;
}

function getIFrameReferer() {
  if (window.location.ancestorOrigins) {
    // Get the top level origin (ancestorOrigins is reversed)
    return window.location.ancestorOrigins[window.location.ancestorOrigins.length - 1];
  }
  return document.referrer;
}

function xhr(url, params, callback) {
 
  var options = params || {};
  if (!url) return;

  var cb = callback || function() {};

  if (options.method.toUpperCase() == "POST") {
    options.headers = options.headers || {};
    if (!options.contentType || options.contentType == 'form') {
      options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      options.data = utils.paramsToStr(options.data);
    } else if (options.contentType == 'json') {
      options.headers['Content-Type'] = 'application/json';
      options.data = JSON.stringify(options.data);
    }
  } else {
    url = utils.addUrlParam(url, options.data);
  }

  videojs.xhr(url, options, cb);
}

function image(url, options = {}) {
  options.data = options.data || {}; 
  if (!url) return;
  var img = new Image();
  if (!options.cache) options.data[Math.round(Math.random() * (9999999999 - 100000) + 100000)] = '';
  img.src = utils.addUrlParam(url, options.data);
}

function paramsToStr(obj) {
  var res = '';

 if (utils.isObject(obj)) {
    res = '';
    for (let i in obj){
      if (res) res += '&';
      res += i + '=' + obj[i];
    }
  }

  return res;
}

function addUrlParam(url, param, val) {
    if (utils.isObject(param)) {
      let result = url;
      for (let i in param) {
        result = utils.addUrlParam(result, i, param[i]);
      }
      return result;
    } else {
      if (url.indexOf(param + '=') != -1) {
        return url.replace(new RegExp(param + '=[^&]*'), param + '=' + val);
      } else {
        let sign = url.indexOf('?') != -1 ? (url.endsWith('?') ? '' : '&') : '?';
        return url + sign + param + '=' + val;
      }
    }
}

function processVal(val, params) {
  return utils.isFunction(val) ? val.call(this, params) :val;
}

function proceedData(data, context, params) {
  var res;

  if (utils.isObject(data)) {
    res = {};
    for (let i in data) {
      res[i] = utils.processVal.call(context, data[i], params);
    }
  } else {
    res = utils.processVal.call(context, data, params);
    if (data && res && !utils.isObject(res)) {
      res = {data: res};
    }
  }

  return res;
}

function isMobile() {
  return /iPhone|iPod|iPad|Mobile|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune|GoogleTV|Smart-?TV|Internet.TV|NetCast|NETTV|Streamium|AppleTV|boxee|Kylo|Roku|DLNADOC|CE\-HTML/i.test(window.navigator.userAgent);
}

function replaceAll(str = '', find, replace) {
  return str.split(find).join(replace);
}

function isAdPlaying(player) {
  return player ? player.vast && player.vast.isAdPlaying() : false;
}

function hasLocalStorage() {
  try {
    window.localStorage.setItem('checkLocalStorage', 'checkLocalStorage');
    window.localStorage.removeItem('checkLocalStorage');
    return true;
  } catch (e) {
    return false;
  }
}

function getUid() {
  var storedUid = hasLocalStorage() ? localStorage["uid"] : uid;
  // Если нет сохраненного значения uid
  if (storedUid === undefined) {
    // Создаем новое
    storedUid = utils.generateUid();
    // Если есть доступ к localStorage
    if (hasLocalStorage()) {
      // То сохраняем значение uid в localStorage
      localStorage["uid"] = storedUid;
    } else {
      // Иначе, храним в переменной
      uid = storedUid;
    }
  }

  return storedUid;
}

function generateUid() {
  var randomString = function(len) {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZ';
      var randomstring = '';
      for (var i = 0; i < len; i++) {
    var rnum = Math.floor(Math.random() * chars.length);
    randomstring += chars.substring(rnum, rnum + 1);
      }
      return randomstring;
  };
  return [
      randomString(8),
      randomString(4),
      randomString(4),
      randomString(4),
      randomString(12)
  ].join('-');
}

function loadScript(url, callback) {
  if (_customScripts[url] || !url) return callback && callback();
    var head = document.getElementsByTagName('head')[0];
    var sc = document.createElement('script');
    sc.type = 'text' + '/javascript';
    sc.src = url;
    if (callback) sc.onload = callback;
    head.appendChild(sc);
    _customScripts[url] = 1;
}

function capitalizeFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

var utils = {
  xhr: xhr,
  image: image,
  addUrlParam: addUrlParam,
  paramsToStr: paramsToStr,
  isObject: isObject,
  isFunction: isFunction,
  isPromise: isPromise,
  isIFrame: isIFrame,
  getIFrameReferer: getIFrameReferer,
  mergeOptions: videojs.mergeOptions,
  processVal: processVal,
  isMobile: isMobile,
  replaceAll: replaceAll,
  isAdPlaying: isAdPlaying,
  getUid: getUid,
  generateUid: generateUid,
  loadScript: loadScript,
  proceedData: proceedData,
  capitalizeFirst: capitalizeFirst
};

export default utils;